<div class="photo-well {{ shape }}" [style.backgroundColor]="color">
  @if (src) {
    <img [src]="src" [alt]="alt">
  } @else if (initials) {
    <span class="initials">{{ initials }}</span>
  }
</div>
